import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 04E66167-8706-4CEF-8748-63BDAAF0F19C
 * name menu-close
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-close.svg
 * tags
 * - Navigation 
 */
export const MenuCloseIcon = createSvgIcon(<><path d="M3 6H13V8H3V6M3 16H13V18H3V16M3 11H15V13H3V11M16 7L14.58 8.39L18.14 12L14.58 15.61L16 17L21 12L16 7Z" /></>, 'MenuCloseIcon');
export default MenuCloseIcon